
import Component from '../../../assets/scripts/modules/component';

import flatpickr from 'flatpickr';
import { english } from "flatpickr/dist/l10n/default.js";
import { Spanish } from "flatpickr/dist/l10n/es.js";

function getLocale() {
  const locale = document.querySelector('html').getAttribute('lang') || 'es';
  if (locale === 'en') {
    return english;
  }
  return Spanish;
}

class FormField extends Component {
  init() {
    this.isDropdown = this.element.classList.contains('form-field--dropdown');
    this.isDate = this.element.classList.contains('form-field--date');

    if (this.isDropdown) {
      this.initDropdown();
    }

    if (this.isDate) {
      this.initDate();
    }
  }

  initDropdown() {
    const select = this.element.querySelector('select');
    const display = this.element.querySelector('[data-role=form-field--current-value]');

    const onSelectChange = () => {
      display.innerText = select.options[select.selectedIndex].innerText;
    };

    select.addEventListener('change', onSelectChange);
  }

  initDate() {
    this.dateDisplay = this.element.querySelector('[data-role="form-field--current-date"]');
    this.dateRange = this.element.querySelector('[data-role="daterange-input"]');

    const onDatePickerChange = () => {
      this.dateDisplay.innerText = this.dateRange.value;
    };

    flatpickr(this.dateRange, {
      mode: 'range',
      animate: false,
      dateFormat: 'd M',
      locale: getLocale(),
      onChange: onDatePickerChange,
    });
  }
}

for (const element of document.querySelectorAll('.form-field')) {
  element.instance = new FormField('form-field', element, { onLoad: true });
}



// WEBPACK FOOTER //
// ./website/components/atoms/form-field/form-field.js